var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6InspectionForms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 83C43 80.2386 45.2386 78 48 78H187.419C190.18 78 192.419 80.2386 192.419 83V267.964C192.419 270.725 190.18 272.964 187.419 272.964H48C45.2386 272.964 43 270.725 43 267.964V83Z",
    fill: "#102F5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 63H187.419C198.465 63 207.419 71.9543 207.419 83V267.964C207.419 279.009 198.465 287.964 187.419 287.964H48C36.9543 287.964 28 279.009 28 267.964V83C28 71.9543 36.9543 63 48 63ZM48 78C45.2386 78 43 80.2386 43 83V267.964C43 270.725 45.2386 272.964 48 272.964H187.419C190.18 272.964 192.419 270.725 192.419 267.964V83C192.419 80.2386 190.18 78 187.419 78H48Z",
    fill: "#102F5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.192 148.335C231.192 145.949 233.126 144.015 235.512 144.015H305.695C308.081 144.015 310.015 145.949 310.015 148.335V262.736C310.015 265.122 308.081 267.057 305.695 267.057H235.512C233.126 267.057 231.192 265.122 231.192 262.736V148.335Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.512 131.053H305.695C315.24 131.053 322.977 138.791 322.977 148.335V262.736C322.977 272.281 315.24 280.019 305.695 280.019H235.512C225.967 280.019 218.23 272.281 218.23 262.736V148.335C218.23 138.79 225.967 131.053 235.512 131.053ZM235.512 144.015C233.126 144.015 231.192 145.949 231.192 148.335V262.736C231.192 265.122 233.126 267.057 235.512 267.057H305.695C308.081 267.057 310.015 265.122 310.015 262.736V148.335C310.015 145.949 308.081 144.015 305.695 144.015H235.512Z",
    fill: "#102F5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.727 155.55H298.48V255.521H242.727V155.55Z",
    fill: "#102F5D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M255.223 155.55L256.332 157.489C258.024 160.451 261.174 162.279 264.585 162.279H276.623C280.034 162.279 283.183 160.451 284.876 157.489L285.984 155.55H255.223Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0596 77.9082H167.434V88.6962C167.434 97.5327 160.271 104.696 151.434 104.696H84.0596C75.223 104.696 68.0596 97.5327 68.0596 88.6961V77.9082Z",
    fill: "#102F5D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.296 202.842C196.273 224.411 198.413 246.276 198.695 268.201H71.5636C71.2806 245.668 69.0846 223.196 64.998 201.029L57.0236 157.773C53.0472 136.203 50.907 114.339 50.6245 92.4136H177.756C178.039 114.947 180.235 137.418 184.322 159.586L192.296 202.842Z",
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.142 199.129C211.43 219.379 215.413 240.658 215.948 262.152H89.3667C88.8296 239.504 84.6459 217.079 76.9668 195.742L62.4607 155.437C55.1725 135.187 51.1897 113.907 50.6545 92.4136H177.236C177.773 115.062 181.956 137.487 189.636 158.823L204.142 199.129Z",
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M217.509 196.277C227.626 214.676 233.285 235.167 234.064 256.103H106.606C105.823 233.481 99.7365 211.334 88.8071 191.459L67.2406 152.24C57.1231 133.841 51.4638 113.35 50.6852 92.4136H178.143C178.926 115.036 185.013 137.183 195.942 157.058L217.509 196.277Z",
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M229.001 191.995C241.422 208.29 248.579 227.939 249.587 248.326H122.297C121.281 225.748 113.401 203.97 99.6515 185.933L71.3028 148.744C58.8813 132.449 51.7244 112.8 50.7159 92.4136H178.007C179.023 114.992 186.902 136.77 200.652 154.807L229.001 191.995Z",
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.014 77.9082C102.014 75.1468 99.7751 72.9082 97.0137 72.9082H91.3911C88.6297 72.9082 86.3911 75.1468 86.3911 77.9082V89.9823C86.3911 95.5706 90.8879 100.191 96.5452 100.191H138.949C144.606 100.191 149.103 95.5706 149.103 89.9823V77.9082C149.103 75.1468 146.864 72.9082 144.103 72.9082H138.48C135.719 72.9082 133.48 75.1468 133.48 77.9082V84.5088H102.014V77.9082Z",
    fill: "white",
    stroke: "#102F5D",
    strokeWidth: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3423 121.979H148.424",
    stroke: "#102F5D",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.032 138.397H163.114",
    stroke: "#102F5D",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114.723 167.777H177.804",
    stroke: "#102F5D",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.413 184.196H192.494",
    stroke: "#102F5D",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M142.375 201.478H205.456",
    stroke: "#102F5D",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M148.424 217.897H211.505",
    stroke: "#102F5D",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6InspectionForms);
export default __webpack_public_path__ + "static/media/6+-inspection-forms.d1240cd031f953d230b36d6a73df3be9.svg";
export { ForwardRef as ReactComponent };